module.exports = __webpack_public_path__ + "f09a507f596b709abc92e3ceeff4dc44.png";